import i18n from '../i18n'
export const t = (key, options = {}) => i18n.t(key.startsWith('shared.') || key.startsWith('javascript.') ? key : `javascript.cards.${key}`, options)
export const languageName = language =>
  i18n.t(`shared.language_names.${language}`, {
    defaultValue: String(language || '').replace(/^./, letter => letter.toUpperCase())
  })
export default i18n
